// extracted by mini-css-extract-plugin
module.exports = {"background":"_3_T9LsZRc_XHhEKB1giI4q","frame":"gwgFE4dNscR1D7ZPnAw1F"};